var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopScholarships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17267",
    "data-name": "Group 17267",
    transform: "translate(19725 15782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-19725 -15771.204) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Degree",
    "data-name": "001---Degree",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.509.524a5.74,5.74,0,0,1,.2,1.275,1.891,1.891,0,0,0-1.9.176A7.363,7.363,0,0,0,6.621.521q.5.01,1.016.01C7.934.532,8.223.528,8.509.524Zm-.6,4.369A1.363,1.363,0,1,1,9.272,3.53,1.363,1.363,0,0,1,7.909,4.893ZM0,2.44A7.644,7.644,0,0,1,.278.123,7.644,7.644,0,0,1,.55,2.44,7.644,7.644,0,0,1,.278,4.756,7.644,7.644,0,0,1,0,2.44ZM.829,4.8A9.039,9.039,0,0,0,1.1,2.44,9.04,9.04,0,0,0,.829.076,47.82,47.82,0,0,0,6.051.507,7.016,7.016,0,0,1,6.274,2.44c0,.04,0,.077,0,.115A1.888,1.888,0,0,0,6.184,4.34l-.012.029A47.5,47.5,0,0,0,.829,4.8Zm6.1,2-.2-.458A.273.273,0,0,0,6.373,6.2l-.459.2.639-1.532a1.906,1.906,0,0,0,.963.526Zm2.515-.6a.273.273,0,0,0-.357.142l-.2.453L8.3,5.4a1.908,1.908,0,0,0,.963-.526L9.9,6.4Zm5.5-1.322a44.14,44.14,0,0,0-5.287-.491l-.019-.047a1.9,1.9,0,0,0-.367-2.149A7.586,7.586,0,0,0,9.072.513,45.494,45.494,0,0,0,14.941,0a6.429,6.429,0,0,1,.327,2.44A6.457,6.457,0,0,1,14.941,4.879Z",
    transform: "translate(0 0)",
    fill: "#f9b316"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 16,
    height: 16,
    transform: "translate(-19725 -15782)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopScholarships);
export default __webpack_public_path__ + "static/media/top_scholarships.c47c44697fe000776aa046c9a26c5f23.svg";
export { ForwardRef as ReactComponent };